import React, {useEffect, useState} from 'react';
import IconLightTheme from '../../UI/Icons/IconLightTheme';
import IconDarkTheme from '../../UI/Icons/IconDarkTheme';
import {useDispatch, useSelector} from 'react-redux';
import {setTheme} from '../../../store/actions/themeActions';

function ThemeSwitch({btnClassName = ''}) {
  const {darkTheme} = useSelector(state => state.theme);
  const dispatch = useDispatch();

  const handleChangeTheme = () => {
    if (darkTheme) {
      document.documentElement.classList.remove('theme--dark');
    } else {
      document.documentElement.classList.add('theme--dark');
    }

    localStorage.setItem('darkTheme', (!darkTheme).toString());

    dispatch(setTheme(!darkTheme));
  };

  useEffect(() => {
    const isDark = localStorage.getItem('darkTheme');

    if (isDark && isDark === 'true') {
      dispatch(setTheme(true));
      document.documentElement.classList.add('theme--dark');
    }
  }, []);

  return (
    <button onClick={handleChangeTheme} className={btnClassName}>
      {darkTheme ? <IconLightTheme/> : <IconDarkTheme/>}
    </button>
  );
}

export default ThemeSwitch;
